/** Layout shell breakpoints (px). Align with Profile xl (1280) and standard md (768). */
export const LAYOUT_BREAKPOINT_MOBILE = 768;
export const LAYOUT_BREAKPOINT_DESKTOP = 1280;

/** Desktop or tablet landscape: side-by-side / inline toolbar layouts. */
export const INLINE_PANEL_LAYOUT_MQ =
  '(min-width: 1280px), (min-width: 768px) and (max-width: 1279px) and (orientation: landscape)';

/** Mouse/trackpad desktop shell: inline sidebar with hover affordances. */
export const HOVER_DESKTOP_MEDIA_QUERY = '(hover: hover) and (pointer: fine)';

export type LayoutMode = 'mobile' | 'tablet' | 'desktop';

export type ResolveLayoutModeOptions = {
  /** When false, wide touch viewports use tablet drawer UX instead of desktop inline sidebar. */
  prefersHoverDesktop?: boolean;
};

export const getPrefersHoverDesktop = (): boolean => {
  if (typeof window === 'undefined') {
    return true;
  }
  return window.matchMedia(HOVER_DESKTOP_MEDIA_QUERY).matches;
};

export const resolveLayoutMode = (
  windowWidth: number,
  options: ResolveLayoutModeOptions = {},
): LayoutMode => {
  const { prefersHoverDesktop = true } = options;

  if (windowWidth < LAYOUT_BREAKPOINT_MOBILE) {
    return 'mobile';
  }

  if (windowWidth >= LAYOUT_BREAKPOINT_DESKTOP && prefersHoverDesktop) {
    return 'desktop';
  }

  return 'tablet';
};
